import React, { createContext, useContext } from 'react'
import { PublicClientApplication, EventType } from '@azure/msal-browser'
import { msalConfig } from './auth-config'

const MsalContext = createContext(null)

export const useMsal = () => useContext(MsalContext)
export const MsalProvider = ({ children, value }) => {
  const msalInstance = value || new PublicClientApplication(msalConfig)
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0])
  }

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
      const { account } = event.payload
      msalInstance.setActiveAccount(account)
    }
  })

  return <MsalContext.Provider value={msalInstance}>{children}</MsalContext.Provider>
}
